<template>
  <div id="supplierView" class="purchase-mgmt-page">
    <div class="page-header">
      <div class="filter-card header-box">
        <div class="filter-row">
          <div class="filter-item">
            <span class="filter-label">供应商类型</span>
            <el-select placeholder="全部" size="small" v-model="params.supplierType" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="主要采购商" :value="1"></el-option>
              <el-option label="一般供应商" :value="2"></el-option>
              <el-option label="临时采购商" :value="3"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">供应商简称</span>
            <el-input placeholder="请输入简称" v-model="params.supplierShortName" size="small" clearable class="filter-input-wide"></el-input>
          </div>
          <div class="filter-item">
            <span class="filter-label">供应商全称</span>
            <el-input placeholder="请输入全称" v-model="params.supplierName" size="small" clearable class="filter-input-wide"></el-input>
          </div>
          <div class="filter-item">
            <span class="filter-label">状态</span>
            <el-select placeholder="全部" size="small" v-model="params.status" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="启用" :value="1"></el-option>
              <el-option label="停用" :value="2"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <el-button type="primary" size="small" icon="el-icon-search" @click="getData">查询</el-button>
            <el-button type="primary" size="small" icon="el-icon-plus" @click="addSupplier">新增供应商</el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="table-panel" ref="tablePanel">
      <div class="table-container">
        <el-table ref="table" :data="tableData" border stripe size="mini" :height="screenHeight" v-loading="loading" element-loading-text="加载中..." header-cell-class-name="table-header-cell" class="mgmt-table">
          <el-table-column type="expand">
            <template slot-scope="scope">
              <el-table :data="scope.row.materials || []" border stripe size="mini" class="expand-material-table">
                <el-table-column label="序号" width="50" align="center">
                  <template slot-scope="inner">{{ inner.$index + 1 }}</template>
                </el-table-column>
                <el-table-column prop="materialName" label="材料名称" min-width="180" show-overflow-tooltip></el-table-column>
                <el-table-column prop="supplierPrice" label="采购价格" width="120" align="right">
                  <template slot-scope="inner">{{ formatPrice(inner.row.supplierPrice) }}</template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>

          <el-table-column label="序号" width="50" align="center">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="supplierId" label="供应商ID" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="supplierShortName" label="供应商简称" width="110" show-overflow-tooltip></el-table-column>
          <el-table-column label="供应商类型" width="110" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" :type="getSupplierTypeTagType(scope.row.supplierType)" disable-transitions>
                {{ getSupplierTypeLabel(scope.row.supplierType) || "-" }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="supplierName" label="供应商全称" min-width="160" show-overflow-tooltip></el-table-column>
          <el-table-column label="开票税点" width="80" align="center">
            <template slot-scope="scope">{{ formatInvoiceTaxRate(scope.row.invoiceTaxRate) }}</template>
          </el-table-column>
          <el-table-column label="可采购材料" min-width="280">
            <template slot-scope="scope">
              <div v-if="(scope.row.materials || []).length" class="material-list">
                <span v-for="(material, index) in scope.row.materials" :key="(material.materialId || material.materialName || '') + '-' + index" class="material-item">{{ index + 1 }}、{{ material.materialName }}</span>
              </div>
              <span v-else class="empty-text">-</span>
            </template>
          </el-table-column>
          <el-table-column label="采购链接" min-width="160" show-overflow-tooltip>
            <template slot-scope="scope">
              <a v-if="getPurchaseLink(scope.row)" :href="getPurchaseLink(scope.row)" target="_blank" rel="noopener noreferrer" class="purchase-link" @click.stop>{{ getPurchaseLink(scope.row) }}</a>
              <span v-else class="empty-text">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.remark || "-" }}</template>
          </el-table-column>
          <el-table-column label="状态" width="80" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" :type="scope.row.status == 1 ? 'success' : 'info'" disable-transitions>
                {{ scope.row.status == 1 ? "启用" : "停用" }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="260" align="center" fixed="right">
            <template slot-scope="scope">
              <div class="action-cell">
                <el-button type="text" size="mini" @click="onViewInvoiceInfo(scope.row)">查看开票信息</el-button>
                <el-button type="text" size="mini" @click="onEditInvoiceInfo(scope.row)">编辑开票信息</el-button>
                <el-button type="text" size="mini" @click="onEditClick(scope.row)">编辑</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-box">
        <el-pagination ref="pageNav" small layout="prev, pager, next" background prev-text="上一页" next-text="下一页" :page-count="pageCount" :page-size="params.pageSize" :total="total" @current-change="handlerPageChange"></el-pagination>
      </div>
    </div>

    <el-dialog title="编辑可采购商品" :visible.sync="purchaseProductDialogVisible" width="1200px">
      <div class="form-line">
        <span class="form-label">产品搜索</span>
        <el-input class="form-input" placeholder="请输入" v-model="searchKey" type="text" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">商品列表</span>
        <el-checkbox-group class="product-group" v-model="productCheckList" style="width: 1050px; display: inline-block; vertical-align: text-top">
          <el-checkbox v-for="pd in searchParentProducts" :label="pd.productType" style="width: 120px; margin-bottom: 5px">{{ pd.productName }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="purchaseProductDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirmCheckProduct">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="supplierDialogTitle" :visible.sync="addSupplierDialogVisible" width="640px" :close-on-click-modal="false" custom-class="supplier-edit-dialog">
      <div class="supplier-dialog-body">
        <div class="supplier-form-section">
          <div class="supplier-section-header">
            <div class="supplier-section-title">基本信息</div>
          </div>
          <el-form label-width="100px" size="small" class="supplier-form-panel">
            <el-form-item label="供应商简称" required>
              <el-input v-model="addParams.supplierShortName" placeholder="请输入供应商简称" clearable></el-input>
            </el-form-item>
            <el-form-item label="供应商全称">
              <el-input v-model="addParams.supplierName" placeholder="请输入供应商全称" clearable></el-input>
            </el-form-item>
            <el-form-item label="供应商类型" required>
              <el-radio-group v-model="addParams.supplierType">
                <el-radio :label="1">主要采购商</el-radio>
                <el-radio :label="2">一般供应商</el-radio>
                <el-radio :label="3">临时供应商</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="开票税率">
              <el-input v-model="addParams.invoiceTaxRate" type="number" placeholder="如 0.13 表示 13%" clearable></el-input>
            </el-form-item>
            <el-form-item label="签合同地址">
              <el-input v-model="addParams.contractSigningAddress" placeholder="请输入签合同地址" clearable></el-input>
            </el-form-item>
            <el-form-item label="采购链接">
              <el-input v-model="addParams.purchaseLink" placeholder="请输入采购链接" clearable></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="addParams.remark" type="textarea" :rows="3" placeholder="请输入备注" clearable></el-input>
            </el-form-item>
            <el-form-item label="状态" required>
              <el-radio-group v-model="addParams.status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="2">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addSupplierDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirmAddSupplier">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑开票信息" :visible.sync="invoiceEditDialogVisible" width="860px" :close-on-click-modal="false" custom-class="supplier-invoice-edit-dialog">
      <div class="invoice-edit-header">
        <span>{{ invoiceEditSupplier.supplierShortName || invoiceEditSupplier.supplierName || "" }}</span>
        <span v-if="invoiceEditSupplier.supplierName && invoiceEditSupplier.supplierShortName" class="invoice-info-sub">{{ invoiceEditSupplier.supplierName }}</span>
      </div>
      <div class="invoice-edit-toolbar">
        <el-button type="primary" plain size="mini" icon="el-icon-plus" @click="addInvoiceInfoItem">新增开票信息</el-button>
      </div>
      <div v-if="!invoiceInfoFormList.length" class="invoice-edit-empty">暂无开票信息，可点击上方按钮新增</div>
      <div v-else class="invoice-edit-list">
        <div v-for="(item, index) in invoiceInfoFormList" :key="item.invoiceInfoId" class="invoice-info-card">
          <div class="invoice-info-card-header">
            <span class="invoice-info-card-title">开票信息 {{ index + 1 }}</span>
            <el-button type="text" size="small" class="danger-text" @click="removeInvoiceInfoItem(index)">删除</el-button>
          </div>
          <el-form label-width="100px" size="small" class="supplier-form-panel">
            <el-form-item label="单位名称">
              <el-input v-model="item.invoiceCompanyName" placeholder="请输入单位名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="税号">
              <el-input v-model="item.invoiceTaxNo" placeholder="请输入税号" clearable></el-input>
            </el-form-item>
            <el-form-item label="单位地址">
              <el-input v-model="item.invoiceCompanyAddress" placeholder="请输入单位地址" clearable></el-input>
            </el-form-item>
            <el-form-item label="电话">
              <el-input v-model="item.invoicePhone" placeholder="请输入电话" clearable></el-input>
            </el-form-item>
            <el-form-item label="开户银行">
              <el-input v-model="item.invoiceBankName" placeholder="请输入开户银行" clearable></el-input>
            </el-form-item>
            <el-form-item label="银行账户">
              <el-input v-model="item.invoiceBankAccount" placeholder="请输入银行账户" clearable></el-input>
            </el-form-item>
            <el-form-item label="收票邮箱">
              <el-input v-model="item.invoiceEmail" placeholder="请输入收票邮箱" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="invoiceEditDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirmInvoiceInfo">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="查看开票信息" :visible.sync="invoiceInfoDialogVisible" width="640px" custom-class="supplier-invoice-info-dialog">
      <div class="invoice-info-header">
        <span>{{ invoiceInfoView.supplierShortName || invoiceInfoView.supplierName || "" }}</span>
        <span v-if="invoiceInfoView.supplierName && invoiceInfoView.supplierShortName" class="invoice-info-sub">{{ invoiceInfoView.supplierName }}</span>
      </div>
      <el-descriptions :column="1" border size="small" class="invoice-info-descriptions invoice-info-tax-rate">
        <el-descriptions-item label="开票税率">{{ formatInvoiceTaxRate(invoiceInfoView.invoiceTaxRate) }}</el-descriptions-item>
        <el-descriptions-item label="签合同地址">{{ displayInvoiceField(invoiceInfoView.contractSigningAddress) }}</el-descriptions-item>
      </el-descriptions>
      <div v-if="!invoiceInfoViewList.length" class="invoice-view-empty">暂无开票信息</div>
      <div v-else class="invoice-view-list">
        <div v-for="(item, index) in invoiceInfoViewList" :key="item.invoiceInfoId || index" class="invoice-view-card">
          <div class="invoice-view-card-title">开票信息 {{ index + 1 }}</div>
          <el-descriptions :column="1" border size="small" class="invoice-info-descriptions">
            <el-descriptions-item label="单位名称">{{ displayInvoiceField(item.invoiceCompanyName) }}</el-descriptions-item>
            <el-descriptions-item label="税号">{{ displayInvoiceField(item.invoiceTaxNo) }}</el-descriptions-item>
            <el-descriptions-item label="单位地址">{{ displayInvoiceField(item.invoiceCompanyAddress) }}</el-descriptions-item>
            <el-descriptions-item label="电话">{{ displayInvoiceField(item.invoicePhone) }}</el-descriptions-item>
            <el-descriptions-item label="开户银行">{{ displayInvoiceField(item.invoiceBankName) }}</el-descriptions-item>
            <el-descriptions-item label="银行账户">{{ displayInvoiceField(item.invoiceBankAccount) }}</el-descriptions-item>
            <el-descriptions-item label="收票邮箱">{{ displayInvoiceField(item.invoiceEmail) }}</el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="invoiceInfoDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { requestModules } from "@r";
export default {
  data() {
    return {
      total: 0,
      pageCount: 1,
      totalPage: 1,
      purchaseProductDialogVisible: false,
      addSupplierDialogVisible: false,
      invoiceInfoDialogVisible: false,
      invoiceEditDialogVisible: false,
      supplierDialogTitle: "新增供应商",
      invoiceInfoView: {},
      invoiceInfoViewList: [],
      invoiceEditSupplier: {},
      invoiceInfoFormList: [],
      tableData: [],
      allTableData: [],
      loading: false,
      beginIndex: 0,
      currentPage: 1,
      date: [new Date(new Date().getTime() - 24 * 3600 * 1000 * 365), new Date(new Date().getTime() + 86400000)],
      params: {
        supplierName: "",
        supplierShortName: "",
        beginIndex: 0,
        pageSize: 50,
        supplierType: "",
        status: 1,
      },
      productCheckList: [],
      editRow: null,
      editParams: {},
      parentProducts: [],
      addParams: {
        supplierId: -1,
        supplierName: "",
        supplierShortName: "",
        purchaseLink: "",
        remark: "",
        _id: "",
        supplierType: 1,
        invoiceTaxRate: 0,
        contractSigningAddress: "",
        status: 1,
      },
      screenHeight: 400,
      searchKey: "",
      searchParentProducts: [],
    };
  },
  watch: {
    searchKey(newValue, oldValue) {
      let list = [];
      this.parentProducts.forEach(pd => pd.productName.indexOf(newValue) != -1 && list.push(pd));
      this.searchParentProducts = [...list];
    },
  },
  mounted() {
    this.getData();
    this.getAllParentProducts();
    this.relayoutTable();
    this.$eventBus && this.$eventBus.$on && this.$eventBus.$on("resize", this.relayoutTable);
    window.addEventListener("resize", this.relayoutTable);
  },
  beforeDestroy() {
    this.$eventBus && this.$eventBus.$off && this.$eventBus.$off("resize", this.relayoutTable);
    window.removeEventListener("resize", this.relayoutTable);
  },
  methods: {
    calculateHeight() {
      const panel = this.$refs.tablePanel;
      if (!panel) return;
      const pagination = panel.querySelector(".pagination-box");
      const panelStyle = window.getComputedStyle(panel);
      const paddingTop = parseFloat(panelStyle.paddingTop) || 0;
      const paddingBottom = parseFloat(panelStyle.paddingBottom) || 0;
      const available = panel.clientHeight - paddingTop - paddingBottom - (pagination ? pagination.offsetHeight : 0);
      this.screenHeight = Math.max(available, 200);
    },
    relayoutTable() {
      this.$nextTick(() => {
        this.calculateHeight();
        this.$nextTick(() => {
          if (this.$refs.table && this.$refs.table.doLayout) {
            this.$refs.table.doLayout();
          }
        });
      });
    },
    addSupplier() {
      this.supplierDialogTitle = "新增供应商";
      this.addParams = {
        supplierId: -1,
        supplierName: "",
        supplierShortName: "",
        purchaseLink: "",
        remark: "",
        _id: "",
        supplierType: 1,
        invoiceTaxRate: 0,
        contractSigningAddress: "",
        status: 1,
      };
      this.addSupplierDialogVisible = true;
    },
    createEmptyInvoiceInfoItem() {
      return {
        invoiceInfoId: "inv_" + Date.now() + "_" + Math.random().toString(36).slice(2, 8),
        invoiceCompanyName: "",
        invoiceTaxNo: "",
        invoiceCompanyAddress: "",
        invoicePhone: "",
        invoiceBankName: "",
        invoiceBankAccount: "",
        invoiceEmail: "",
      };
    },
    normalizeInvoiceInfoList(row) {
      if (row.invoiceInfoList && row.invoiceInfoList.length) {
        return row.invoiceInfoList.map(item => {
          let emptyItem = this.createEmptyInvoiceInfoItem();
          return Object.assign(emptyItem, item, {
            invoiceInfoId: item.invoiceInfoId || emptyItem.invoiceInfoId,
          });
        });
      }
      if (
        row.invoiceCompanyName ||
        row.invoiceTaxNo ||
        row.invoiceCompanyAddress ||
        row.invoicePhone ||
        row.invoiceBankName ||
        row.invoiceBankAccount ||
        row.invoiceEmail
      ) {
        return [
          Object.assign(this.createEmptyInvoiceInfoItem(), {
            invoiceInfoId: "legacy",
            invoiceCompanyName: row.invoiceCompanyName || "",
            invoiceTaxNo: row.invoiceTaxNo || "",
            invoiceCompanyAddress: row.invoiceCompanyAddress || "",
            invoicePhone: row.invoicePhone || "",
            invoiceBankName: row.invoiceBankName || "",
            invoiceBankAccount: row.invoiceBankAccount || "",
            invoiceEmail: row.invoiceEmail || "",
          }),
        ];
      }
      return [];
    },
    getAllParentProducts() {
      requestModules.fetchParentProducts({}).then(res => {
        this.parentProducts = res.ldata;
        this.parentProducts.sort((a, b) => a.productType - b.productType);
        this.searchParentProducts = [...this.parentProducts];
      });
    },
    getSupplierTypeLabel(supplierType) {
      let label = "";
      supplierType == 1 && (label = "主要采购商");
      supplierType == 2 && (label = "一般供应商");
      supplierType == 3 && (label = "临时供应商");
      return label;
    },
    getSupplierTypeTagType(supplierType) {
      if (supplierType == 1) return "";
      if (supplierType == 2) return "info";
      if (supplierType == 3) return "warning";
      return "info";
    },
    getPurchaseLink(row) {
      if (!row || !row.purchaseLink) return "";
      try {
        return decodeURIComponent(row.purchaseLink);
      } catch (e) {
        return row.purchaseLink;
      }
    },
    formatPrice(value) {
      const num = parseFloat(value);
      if (Number.isNaN(num)) return "-";
      return num.toFixed(2);
    },
    detail(row) {
      window.open("/client/outStockMgmt/detail?planId=" + row.planId);
    },
    getData() {
      this.loading = true;
      requestModules
        .fetchSuppliers(this.params)
        .then(res => {
          this.tableData = res.ldata || [];
          this.total = res.total || 0;
        })
        .finally(() => {
          this.loading = false;
          this.relayoutTable();
        });
    },
    handleConfirmCheckProduct() {
      console.log(this.productCheckList);

      let params = {
        productCheckList: JSON.stringify(this.productCheckList),
        _id: this.editRow._id,
      };
      requestModules
        .addOrUpdateSupplier(params)
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "添加供应商名称失败",
            });
            return;
          }
          this.$message({
            type: "success",
            message: "添加成功",
          });
          this.getData();

          this.purchaseProductDialogVisible = false;
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err.message ? err.message : "添加供应商名称失败",
          });
        });
    },
    handleConfirmAddSupplier() {
      if (this.addParams.supplierShortName == "") {
        this.$message({
          type: "warning",
          message: "请输入供应商简称",
        });
        return;
      }

      this.addParams.purchaseLink = encodeURIComponent(this.addParams.purchaseLink);

      requestModules
        .addOrUpdateSupplier(this.addParams)
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "添加供应商名称失败",
            });
            return;
          }
          this.$message({
            type: "success",
            message: "添加成功",
          });
          this.getData();
          this.addSupplierDialogVisible = false;
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err.message ? err.message : "添加供应商名称失败",
          });
        });
    },
    onEditPurchaseProductClick(row) {
      this.editRow = row;
      this.productCheckList = this.editRow.productCheckList ? [...this.editRow.productCheckList] : [];
      this.purchaseProductDialogVisible = true;
    },
    onEditClick(row) {
      this.editRow = row;
      this.supplierDialogTitle = "编辑供应商";
      this.addParams.supplierId = row.supplierId;
      this.addParams.supplierName = row.supplierName;
      this.addParams.supplierShortName = row.supplierShortName;
      this.addParams.purchaseLink = row.purchaseLink ? decodeURIComponent(row.purchaseLink) : "";
      this.addParams.remark = row.remark;
      this.addParams._id = row._id;
      this.addParams.supplierType = row.supplierType > 0 ? row.supplierType : "";
      this.addParams.invoiceTaxRate = row.invoiceTaxRate != null ? row.invoiceTaxRate : 0;
      this.addParams.contractSigningAddress = row.contractSigningAddress || "";
      this.addParams.status = row.status;
      this.addSupplierDialogVisible = true;
    },
    onEditInvoiceInfo(row) {
      this.editRow = row;
      this.invoiceEditSupplier = { ...row };
      this.invoiceInfoFormList = this.normalizeInvoiceInfoList(row).map(item => ({ ...item }));
      this.invoiceEditDialogVisible = true;
    },
    addInvoiceInfoItem() {
      this.invoiceInfoFormList.push(this.createEmptyInvoiceInfoItem());
    },
    removeInvoiceInfoItem(index) {
      this.invoiceInfoFormList.splice(index, 1);
    },
    handleConfirmInvoiceInfo() {
      if (!this.editRow || !this.editRow._id) {
        this.$message({
          type: "warning",
          message: "缺少供应商信息",
        });
        return;
      }

      requestModules
        .updateSupplierInvoiceInfo({
          _id: this.editRow._id,
          invoiceInfoList: JSON.stringify(this.invoiceInfoFormList),
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "保存开票信息失败",
            });
            return;
          }
          this.$message({
            type: "success",
            message: "保存成功",
          });
          this.invoiceEditDialogVisible = false;
          this.getData();
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err.message ? err.message : "保存开票信息失败",
          });
        });
    },
    onViewInvoiceInfo(row) {
      this.invoiceInfoView = { ...row };
      this.invoiceInfoViewList = this.normalizeInvoiceInfoList(row);
      this.invoiceInfoDialogVisible = true;
    },
    displayInvoiceField(value) {
      return value ? value : "-";
    },
    formatInvoiceTaxRate(value) {
      let taxRate = parseFloat(value);
      if (isNaN(taxRate) || taxRate <= 0) {
        return "0%";
      }
      return (taxRate * 100).toFixed(0) + "%";
    },
    getProductName(productType) {
      let parentProduct = this.parentProducts.find(pd => pd.productType == productType);
      return parentProduct ? parentProduct.productName : "";
    },
    handlerPageChange() {
      let pageNav = this.$refs.pageNav;
      // let lastEmittedPage = pageNav.lastEmittedPage;
      let internalCurrentPage = pageNav.internalCurrentPage;
      this.params.beginIndex = (internalCurrentPage - 1) * this.params.pageSize;
      this.getData();
    },
  },
};
</script>

<style lang="scss">
@import "../../../assets/styles/purchaseMgmtPage.scss";

#supplierView {
  .filter-input-wide {
    width: 160px !important;
  }

  .pagination-box {
    padding-top: 12px;
    padding-bottom: 0;
    min-height: 0;

    .el-pagination {
      padding: 0;
      font-weight: 400;

      &.is-background .btn-prev,
      &.is-background .btn-next,
      &.is-background .el-pager li {
        min-width: 28px;
        height: 28px;
        line-height: 28px;
        margin: 0 3px;
        font-size: 12px;
      }

      button,
      span:not([class*="suffix"]) {
        height: 28px;
        line-height: 28px;
        font-size: 12px;
      }
    }
  }

  .expand-material-table {
    width: calc(100% - 48px);
    margin: 8px 0 8px 48px;
  }

  .material-list {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 12px;
    line-height: 1.5;
    padding: 2px 0;
  }

  .material-item {
    display: inline-block;
    max-width: 100%;
    word-break: break-all;
    color: #606266;
  }

  .purchase-link {
    color: #409eff;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .empty-text {
    color: #c0c4cc;
  }

  .action-cell {
    white-space: nowrap;

    .el-button {
      margin-left: 0;
      margin-right: 4px;
      padding: 0 4px;
    }
  }

  .form-line {
    .form-label {
      margin: 5px 20px 5px 0px;
      width: 80px;
      font-weight: bold;
      text-align: right;
      display: inline-block;
      vertical-align: middle;
      span {
        color: red;
      }
    }
    .form-input {
      width: 220px;
      margin: 5px 0px;
      vertical-align: middle;
    }
  }
}

.supplier-edit-dialog {
  .el-dialog__body {
    padding: 16px 20px 10px;
  }

  .supplier-dialog-body {
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-height: 68vh;
    overflow-y: auto;
  }

  .supplier-form-section {
    background: #fafafa;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 14px 16px;
  }

  .supplier-section-header {
    margin-bottom: 12px;
  }

  .supplier-section-title {
    color: #303133;
    font-size: 14px;
    font-weight: 600;
    line-height: 1;
    padding-left: 8px;
    border-left: 3px solid #409eff;
  }

  .supplier-form-panel {
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 12px 16px 2px;

    .el-form-item {
      margin-bottom: 14px;

      &:last-child {
        margin-bottom: 8px;
      }
    }

    .el-input,
    .el-textarea {
      width: 100%;
    }

    .el-radio {
      margin-right: 16px;
    }
  }
}

.supplier-invoice-info-dialog {
  .invoice-info-header {
    margin-bottom: 12px;
    font-size: 15px;
    font-weight: 600;
    color: #303133;
  }

  .invoice-info-sub {
    margin-left: 12px;
    font-size: 13px;
    font-weight: 400;
    color: #909399;
  }

  .invoice-info-descriptions {
    width: 100%;
  }

  .invoice-info-tax-rate {
    margin-bottom: 12px;
  }

  .invoice-view-empty {
    padding: 24px 0;
    text-align: center;
    color: #909399;
    font-size: 13px;
  }

  .invoice-view-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-height: 60vh;
    overflow-y: auto;
  }

  .invoice-view-card {
    background: #fafafa;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 12px 14px;
  }

  .invoice-view-card-title {
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    padding-left: 8px;
    border-left: 3px solid #409eff;
  }
}

.supplier-invoice-edit-dialog {
  .el-dialog__body {
    padding: 16px 20px 10px;
  }

  .invoice-edit-header {
    margin-bottom: 12px;
    font-size: 15px;
    font-weight: 600;
    color: #303133;
  }

  .invoice-info-sub {
    margin-left: 12px;
    font-size: 13px;
    font-weight: 400;
    color: #909399;
  }

  .invoice-edit-toolbar {
    margin-bottom: 12px;
  }

  .invoice-edit-empty {
    padding: 32px 0;
    text-align: center;
    color: #909399;
    font-size: 13px;
    background: #fafafa;
    border: 1px dashed #dcdfe6;
    border-radius: 8px;
  }

  .invoice-edit-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-height: 58vh;
    overflow-y: auto;
  }

  .invoice-info-card {
    background: #fafafa;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 12px 14px;
  }

  .invoice-info-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .invoice-info-card-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    padding-left: 8px;
    border-left: 3px solid #409eff;
  }

  .danger-text {
    color: #f56c6c;
  }

  .supplier-form-panel {
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 12px 16px 2px;

    .el-form-item {
      margin-bottom: 14px;

      &:last-child {
        margin-bottom: 8px;
      }
    }

    .el-input,
    .el-textarea {
      width: 100%;
    }
  }
}
</style>
